import { Button, Divider, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import ClientiHeadTable from './ClientiHeadTable';


export default class ClientiFinanciar extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }
    render() {
        return (

            <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>



                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.financiar.clienti}</h5>


                            <Divider className='pm-divider' />
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>


                            <ClientiHeadTable
                                clienti={this.props.clientiHead}
                                editClienti={this.props.editClienti}
                                dictionary={this.dictionary}
                            />





                            <Divider className='pm-divider' />

                        </Grid>


                        <Grid style={{ textAlign: 'left', paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                            <Button
                                style={{ marginRight: 20 }}

                                className={'add-button-blue'} onClick={() => { this.props.editClienti(this.props.clientiHead[0]) }}  >

                                <i style={{
                                    fontSize: 14,
                                    marginRight: 10
                                }} className='material-icons'>edit</i>  {this.dictionary.financiar.editeazaClienti}
                            </Button>

                            <Button
                                style={{ marginRight: 20 }}

                                className={'inapoi-button-blue'} onClick={this.props.inapoi}  >

                                <i style={{
                                    fontSize: 14,
                                    marginRight: 10
                                }} className='material-icons'>keyboard_arrow_left</i>  {this.dictionary.financiar.inapoi}
                            </Button>
                        </Grid>






                    </Grid>




                </Grid>



            </Grid>

        );
    }
}